export default {
  data(){
    return {
      noPullToRefreshClass : 'akibatrical-no-pull-to-refresh-android'
    };
  },

  computed  : {
    isNoBodyPullToRefreshAndroid(){
      return this.$store.state.layouts.isNoBodyPullToRefreshAndroid;
    }
  },

  watch : {
    isNoBodyPullToRefreshAndroid(value) {
      switch(value){
        case true:
          this.bodyNoPullToRefreshAndroidON();
        break;

        case false:
          this.bodyNoPullToRefreshAndroidOFF();
        break;
      }
    },
  },

  methods : {
    bodyNoPullToRefreshAndroidON(){
      if(!document.querySelector('body').classList.contains(this.noPullToRefreshClass)){
        document.querySelector('body').classList.add(this.noPullToRefreshClass);
      }
    },

    bodyNoPullToRefreshAndroidOFF(){
      if(document.querySelector('body').classList.contains(this.noPullToRefreshClass)){
        document.querySelector('body').classList.remove(this.noPullToRefreshClass);
      }
    }
  },
}